export const DEFAULT_POLICY = {
  editableFields: [],
};
